import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(p) { super(p); this.state = { err: null }; }
  static getDerivedStateFromError(err) { return { err }; }
  componentDidCatch(err, info) { console.error("UI error", err, info); }
  render() {
    if (!this.state.err) return this.props.children;
    return (
      <div className="p-6 text-sm" data-testid="error-boundary">
        <div className="mb-2">{this.props.message || "Something went wrong on this step."}</div>
        <button className="btn" onClick={() => { this.setState({ err: null }); this.props.onReset?.(); }} data-testid="error-retry-btn">Try again</button>
      </div>
    );
  }
}
